import React from "react";
import { Nav } from "react-bootstrap";

const LoginLeftSide: React.FC = () => {
  return (
    <>
      <div className="leftImgWrap">
            
                <div className="leftImgWrap-content">  
                    <h4>High-Performance GPUaaS Platform <br className="d-none d-lg-block" />
for Scalable Compute Power.</h4>
                    <p>Instantly launch and manage GPU-powered virtual machines built <br className="d-none d-lg-block" />for AI, ML, and high-performance workloads.</p>
                    
                </div>
          </div>
    </>
  );
};

export default LoginLeftSide;
